import { render, staticRenderFns } from "./ManualTransactionModal.vue?vue&type=template&id=28404844&"
import script from "./ManualTransactionModal.vue?vue&type=script&lang=js&"
export * from "./ManualTransactionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports